import React from 'react';
import PropTypes from 'prop-types';

import ProgressIndicator from 'eventbrite_design_system/progressIndicator/ProgressIndicator';
import gettext from 'js-utils/gettext';

import './LoadingScreen.scss';

export const DefaultIcon = (
    <ProgressIndicator shape="circular" style="gradient" />
);

const LoadingScreen = ({ icon, isShown, text }) =>
    isShown ? (
        <div className="loading-screen-container eds-loading-overlay eds-bg-color--background">
            <div className="eds-g-group">
                <div className="eds-g-cell eds-g-cell-1-1 eds-l-mar-top-20 eds-l-sm-mar-top-8 eds-l-pad-top-20 eds-l-pad-bot-10 eds-text--center">
                    {icon}
                </div>
                <div className="eds-g-cell eds-g-cell-1-1">
                    <div className="eds-text--center">
                        <h2 className="eds-text-color--grey-900 eds-text-hm">
                            {gettext(text)}
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    ) : null;

LoadingScreen.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    isShown: PropTypes.bool,
    text: PropTypes.string,
};

LoadingScreen.defaultProps = {
    icon: DefaultIcon,
    isShown: false,
    text: '',
};

export default LoadingScreen;
